import { Dimensions, PixelRatio, Platform, NativeModules } from 'react-native';
import System from 'utils/System';
import CommonBridge from './CommonBridge';
import {
  Dimens,
  Scaledp,
  ScaleFontSize,
  ScaleLineHeight,
  ScaleStyle,
  DEFAULT_WIDTH_DP_UI,
  noPadScale,
  noScale,
} from './Dimens';

const SystemUIAndroid = NativeModules.SystemUIAndroid;

const _statusBarHeight = (() => {
  if (Platform.OS === 'web') {
    return 0;
  } else if (System.isIPhoneX()) {
    return 44;
  } else if (CommonBridge.isAndroid()) {
    return CommonBridge.StatusBarHeight / PixelRatio.get();
  } else if (CommonBridge.isWxminiprogram() && !CommonBridge.isWeb()) {
    return CommonBridge.StatusBarHeight;
  } else {
    return 20;
  }
})();
export const getWinInfo = () => {
  const DimensionsWidth = Dimensions.get('window').width;
  const DimensionsHeight = Dimensions.get('window').height;
  if (Platform.OS == 'web') {
    const winW =
      (document && document.documentElement && document.documentElement.clientWidth) ||
      (document && document.body && document.body.clientWidth) ||
      DimensionsWidth;
    const winH =
      (document && document.documentElement && document.documentElement.clientHeight) ||
      (document && document.body && document.body.clientHeight) ||
      DimensionsHeight;
    const curWidth = Math.min(winW, DimensionsWidth);
    const curHeight = Math.min(winH, DimensionsHeight);
    return {
      curWidth: !CommonBridge.isTablet() && curWidth > 600 ? 600 : curWidth,
      curHeight: curHeight,
    };
  } else {
    return {
      curWidth: DimensionsWidth,
      curHeight: DimensionsHeight,
    };
  }
};
const CommonStyles = {
  androidFontStyle: CommonBridge.isMishopApp()
    ? {
        // 米网安卓价格字体Avenir
        fontFamily: 'Mitype-DemiBold',
      }
    : {
        fontFamily: 'sans-serif',
      },
  iosFontStyle:
    CommonBridge.isIOS() && CommonBridge.OsVersion < 9
      ? {
          fontFamily: 'PingFangSC-Regular',
        }
      : {},
  statusBarHeight: _statusBarHeight,
  navBarHeight: _statusBarHeight + 44, // standardNavHeight
  pageContainerBottomSpace: System.isIPhoneX()
    ? 34
    : SystemUIAndroid?.NavigationBarHeight
    ? SystemUIAndroid?.NavigationBarHeight / PixelRatio.get() - 2
    : 0,
  Scaledp,
  ScaleFontSize,
  ScaleLineHeight,
  ScaleStyle,
  DeviceScale: 1,
  noPadScale,
  noScale,
  ViewHeight: getWinInfo().curHeight,
  ViewWidth: getWinInfo().curWidth,
  titleBar: {
    height: CommonBridge.isWxminiprogram() ? 42 : 44,
    backgroundColor: 'transparent',
    sepLineColor: '#BFBFC0',
    margin: 12,
    btnSpace: 8,
  },
  titleBarButton: {
    width: 50,
    height: 50,
    marginLeft: 1,
  },
  titleBarButtonRedNum: {
    position: 'absolute',
    width: 14,
    height: 14,
    right: 5,
    top: 5,
    borderRadius: 7,
  },
  detailbottomBar: {
    height: 53,
    backgroundColor: '#F2F2F2',
    borderTopWidth: 1 / PixelRatio.get(),
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderColor: '#BFBFC0',
  },
  DEFAULT_WIDTH_DP_UI: DEFAULT_WIDTH_DP_UI,
  touchHighlightBackground: 'rgba(0, 0, 0, 0.04)',
  MishopMainColor: '#FF5900',
  screenLayoutSize: 2,
  isInFold: false,
  fontWeight500: {
    fontWeight: CommonBridge.isAndroid() ? 'bold' : '500',
  },
};

export default CommonStyles;
